import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Routes,
} from '@angular/router';
import { NavigationTemplateComponent } from '@context/frontend/navigation';
import {
	AuthGuard,
	CustomAuthGuard,
	ProfileAccessGuard,
	redirectUnauthorizedTo,
	RoleAccessGuard,
	SelectOrganizationAccessGuard,
	SplashGuard,
} from '@context/frontend/user';
import { Role } from '@context/shared/types/user';

export const appRoutes: Routes = [
	{
		path: 'support',
		loadChildren: () => import('./pages/support/support.routes'),
	},
	{
		path: 'policy',
		loadChildren: () => import('./pages/policy/policy.routes'),
	},
	{
		path: 'invite',
		canActivate: [SplashGuard],
		loadChildren: () => import('./pages/invite/invite.routes'),
	},
	{
		path: 'auth',
		canActivate: [SplashGuard],
		loadChildren: () => import('./pages/auth/auth.routes'),
	},
	{
		path: 'select-organization',
		canActivate: [AuthGuard, SelectOrganizationAccessGuard],
		loadChildren: () =>
			import('./pages/select-organization/select-organization.routes'),
	},
	{
		path: '',
		component: NavigationTemplateComponent,
		canActivate: [AuthGuard, CustomAuthGuard],
		data: {
			authGuardPipe: (
				_r: ActivatedRouteSnapshot,
				{ url }: RouterStateSnapshot,
			) =>
				redirectUnauthorizedTo(
					`auth?redirectUrl=${encodeURIComponent(url)}`,
				),
		},
		children: [
			{
				path: 'home',
				loadChildren: () => import('./pages/home/home.routes'),
			},
			{
				path: 'archive',
				loadChildren: () => import('./pages/archive/archive.routes'),
			},
			{
				path: 'profile',
				canActivate: [ProfileAccessGuard],
				loadChildren: () => import('./pages/profile/profile.routes'),
			},
			{
				path: 'notifications',
				loadChildren: () =>
					import('./pages/notifications/notifications.routes'),
			},
			{
				path: 'users',
				loadChildren: () => import('./pages/users/users.routes'),
				canActivate: [RoleAccessGuard],
				data: { role: 'admin' as Role },
			},
			{
				path: 'organization',
				loadChildren: () =>
					import('./pages/organization/organization.routes'),
				canActivate: [RoleAccessGuard],
				data: { role: 'owner' as Role },
			},
			{
				path: 'chemicals',
				loadChildren: () =>
					import('./pages/chemicals/chemicals.routes'),
			},
			{
				redirectTo: 'home',
				path: '**',
			},
		],
	},
	{
		redirectTo: 'home',
		path: '**',
	},
];
